import { Dialog } from "@kobalte/core/dialog";
import { A } from "@solidjs/router";
import { AnimateChildren } from "@storytell/ui/animation";
import { StButton } from "@storytell/ui/buttons";
import { TbLock, TbX } from "solid-icons/tb";
import { Show } from "solid-js";
import { useWire } from "~/wire";

export const SignInRequiredModal = () => {
  const wire = useWire();
  return (
    <AnimateChildren
      show={wire.ui.authGate.isModalOpen()}
      enter={{ opacity: [0, 1], y: [10, 0] }}
      exit={{ opacity: [1, 0], y: [0, 10] }}
    >
      {(anim) => (
        <Dialog
          open={anim.isMounted()}
          onOpenChange={(val) => {
            if (!val) wire.ui.authGate.closeModal();
          }}
        >
          <Dialog.Portal>
            <Dialog.Overlay class="fixed z-90 inset-0 bg-black/50 dark:bg-white/10" />
            <div ref={anim.ref} class="fixed z-90 inset-0 flex items-center justify-center">
              <Dialog.Content class="max-h-[80vh] relative w-screen text-primary-text max-w-xl bg-panel overflow-y-auto rounded-xl p-8">
                <Dialog.CloseButton as={StButton} class="absolute top-4 right-4">
                  <TbX />
                </Dialog.CloseButton>

                <div class="flex items-center gap-3 mb-6">
                  <TbLock class="w-6 h-6 text-muted-text" />
                  <h3 class="text-lg font-medium">{wire.ui.authGate.state()?.title}</h3>
                </div>

                <Show when={wire.ui.authGate.state()?.description}>
                  <p class="mb-6 text-sm text-muted-text">{wire.ui.authGate.state()?.description}</p>
                </Show>

                <div class="flex items-center gap-2 ml-auto justify-end">
                  <StButton
                    as={A}
                    href="/auth/signup"
                    onClick={() => wire.ui.authGate.closeModal()}
                    class="text-sm px-4 py-2 text-on-brand bg-brand hover:bg-brand-hover"
                  >
                    Sign Up
                  </StButton>
                  <span class="text-secondary-text">or</span>
                  <A
                    href="/auth/signin"
                    onClick={() => wire.ui.authGate.closeModal()}
                    class="text-sm text-brand hover:text-brand-hover underline font-medium"
                  >
                    Sign In
                  </A>
                </div>
              </Dialog.Content>
            </div>
          </Dialog.Portal>
        </Dialog>
      )}
    </AnimateChildren>
  );
};
